import * as React from 'react';
import classes from '../PostingPlan.module.scss';
import { Button } from '../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { IconsEnum } from '../../../../constants/icons';
import { Void } from '../../../../models/basic-objects';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { BreakpointsEnum } from '../../../../constants/breakpoints';
import { useRef } from 'react';
import { useDimensions } from '../../../../hooks/useDimensions';
import { BreakpointsValuesEnum } from '../../../../constants/breakpoints-values';

export type InformationBannerProps = {
  buttonAction: Void;
};
export const InformationBanner = ({ buttonAction }: InformationBannerProps): JSX.Element => {
  const breakpoint = useBreakpoints();

  const bodyRef = useRef(document.body);
  const { width } = useDimensions(bodyRef);

  const message = 'Click anywhere on your Posting Plan to add more timeslots';

  return (
    <>
      {breakpoint === BreakpointsEnum.small ? (
        <></>
      ) : (
        <div className={classes.CloneModeInformationBannerWrapper}>
          <div className={classes.CloneModeInformationBanner}>
            <div className={'grid-x grid-padding-x align-center-middle full-height'}>
              <div className={'cell auto'}>
                {width > BreakpointsValuesEnum.tabletportrait ? <h3>{message}</h3> : <h5>{message}</h5>}
              </div>
              <div className={'cell shrink'}>
                <Button
                  type={'button'}
                  variant={'solid'}
                  size={'medium'}
                  color={ButtonColorsEnum.secondary}
                  icon={{ value: IconsEnum.tick, side: 'left' }}
                  action={buttonAction}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
